// frontend/src/components/Profile/AllEventsModal.js
import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, IconButton,
  Box, Typography, alpha, useTheme
} from '@mui/material';
import {
  Close as CloseIcon,
  Event as EventIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import ProfileEventCard from './ProfileEventCard';
import { useNavigate } from 'react-router-dom';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(3),
    maxWidth: '90vw',
    width: 'auto',
    minWidth: 400,
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.paper
  }
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

const EventsGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2.5),
  padding: theme.spacing(3),
  justifyContent: 'flex-start',
}));

const EmptyState = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 400,
  width: '100%'
});

const AllEventsModal = ({ open, onClose, events = [] }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleEventClick = (event) => {
    navigate(`/events/${event.id}`);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={false} fullWidth={false}>
      <StyledDialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EventIcon sx={{ fontSize: 28 }} />
          <Typography variant="h6" component="div" fontWeight="700">
            Мероприятия
          </Typography>
          <Typography variant="body2" component="span" sx={{ color: 'white', opacity: 0.8 }}>
            ({events.length})
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>

      <DialogContent>
        {events.length === 0 ? (
          <EmptyState>
            <EventIcon sx={{ fontSize: 64, color: theme.palette.text.disabled, mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              Нет мероприятий
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Пользователь пока не участвует ни в одном мероприятии
            </Typography>
          </EmptyState>
        ) : (
          <EventsGrid>
            {events.map((event) => (
              <Box key={event.id} sx={{
                width: { xs: '100%', sm: 'calc(50% - 10px)', md: 'calc(33.333% - 17px)' },
                minWidth: { xs: 'auto', sm: '280px', md: '280px' },
                maxWidth: { xs: '100%', sm: '310px', md: '310px' },
                display: 'flex'
              }}>
                <ProfileEventCard
                  event={event}
                  onClick={() => handleEventClick(event)}
                />
              </Box>
            ))}
          </EventsGrid>
        )}
      </DialogContent>
    </StyledDialog>
  );
};

export default AllEventsModal;